import { render } from "./App.vue?vue&type=template&id=1797591f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1797591f&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__